<ng-container *ngIf="item.items?.length > 0 && userCanAccessPage(item)">
    <mat-expansion-panel (click)="sideNavOpenedChange.emit(true);"
    [expanded]="expansionPanel.isActive"
    #expansionPanel="routerLinkActive"
    [routerLinkActive]="'active'" >
        <mat-expansion-panel-header>
        <mat-panel-title>
            <mat-icon *ngIf="sideNavOpened" class="material-icons-outlined" mat-list-icon>{{item.icon}}</mat-icon>
            <mat-icon *ngIf="!sideNavOpened" class="material-icons-outlined" mat-list-icon [matTooltip]="item.name" matTooltipPosition="right">{{item.icon}}</mat-icon>
            <span *ngIf="sideNavOpened">{{item.name}}</span>
        </mat-panel-title>
        </mat-expansion-panel-header>
        <ng-container *ngIf="sideNavOpened">
        <div *ngFor="let subMenuItem of item.items">
            <a *ngIf="subMenuItem.routeUrl && userCanAccessPage(subMenuItem) && (!subMenuItem.items || subMenuItem.items.length == 0)" class="submenu-item" [routerLink]="subMenuItem.routeUrl" routerLinkActive="active">
                {{subMenuItem.name}}
            </a>
            <a *ngIf="subMenuItem.childApplicationUserId && userCanAccessPage(subMenuItem) && (!subMenuItem.items || subMenuItem.items.length == 0)" class="submenu-item" (click)="openApplicationLink(subMenuItem)">
                {{subMenuItem.name}}
            </a>
            <ng-container *ngIf="subMenuItem.items?.length > 0 && userCanAccessPage(subMenuItem)">
                <div class="submenu-item--header">{{subMenuItem.name}}</div>
                <ng-container *ngFor="let level2SubMenuItem of subMenuItem.items">
                    <a *ngIf="level2SubMenuItem.routeUrl && userCanAccessPage(level2SubMenuItem)" class="submenu-item--level2" [routerLink]="level2SubMenuItem.routeUrl" routerLinkActive="active">
                        {{level2SubMenuItem.name}}
                    </a>
                    <a *ngIf="level2SubMenuItem.appUrl && userCanAccessPage(level2SubMenuItem)" class="submenu-item--level2" [routerLink]="level2SubMenuItem.routeUrl" routerLinkActive="active">
                        {{level2SubMenuItem.name}}
                    </a>
                </ng-container>
            </ng-container>
        </div>
        </ng-container>
    </mat-expansion-panel>
</ng-container>

<ng-container *ngIf="userCanAccessPage(item) && (!item.items || item.items?.length == 0)">
    <a mat-list-item class="item" [routerLink]="item.routeUrl" routerLinkActive="active" (click)="accordion.closeAll();">
        <mat-icon *ngIf="sideNavOpened" class="material-icons-outlined" mat-list-icon>{{item.icon}}</mat-icon>
        <mat-icon *ngIf="!sideNavOpened" class="material-icons-outlined" mat-list-icon [matTooltip]="item.name" matTooltipPosition="right">{{item.icon}}</mat-icon>
        <span *ngIf="sideNavOpened">{{item.name}}</span>
    </a>
</ng-container>
